export default __webpack_public_path__ + "static/media/allianz2.b02ed490.svg";